<template>
  <el-dialog
    :visible.sync="isVisible"
    custom-class="dialog-long-form"
    :class="{'is-edit-mode': isEditMode, 'is-new': state === 'new'}"
    :closeOnClickModal="false"
    append-to-body
    :show-close="false"
    @close="handleDialogClose"
  >
    <template v-slot:title>
      <slot :title="formTitle" />
    </template>
    <div v-loading="isLoading">
      <form-editor
        disabledPart
        :disabled="disabled"
        :data="data"
        :model="formModel"
        :hasCreateNew="hasCreateNew"
        @open-file="handleOpenFile"
        @onAutoSave="mixAutoSave"
        @change="handleFormData"
        @updateViewData="handleViewData"
        ref="Form"/>
      <form-controls
        class="form-footer"
        :isBack="hasCreateNew"
        :isCancel="!hasCreateNew"
        :isCreate="!hasCreateNew && !disabled"
        :isSave="hasCreateNew && !disabled"
        :isDelete="false"
        @command="setCommand">
        <div v-if="hasCreateNew" class="control btn-mobile-full" style="order: 3">
          <ui-button
            class="btn-size-s btn-mobile-full"
            :disabled="canOpenRepairStatus"
            @click="handleOpenRepairStatus"
          >
            {{L10n('open-repair-status')}}
          </ui-button>
        </div>
        <div v-if="hasCreateNew" class="control btn-mobile-full" style="order: 4">
          <ui-button
            v-if="isAllowToEditRFQs"
            class="btn-size-s btn-mobile-full"
            :disabled="data.statusID !== 1"
            @click="handlerQuickRFQ"
          >
            {{L10n('quick-rfq')}}
          </ui-button>
        </div>
      </form-controls>
    </div>
    <dialog-connect-wo
      ref="dialog-connect-wo"
      filterFieldName="partID"
      :filterValueTemplate="filterValueTemplate"
    />
    <dialog-status-repair-order />
    <dialog-new-instruction-repair-order/>
  </el-dialog>
</template>

<script>

import FormWrapper from '@/components/Form/FormWrapper'
import { ModelStock } from '@/services/Stocks'
import OpenFile from '@/modules/OpenFile'
import { AutoSaveMixin } from '@/mixins/FormAutoSave'

export default {
  name: 'ModalNewLabel',
  mixins: [FormWrapper, AutoSaveMixin],
  components: {
    'form-editor': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/Stock/form.vue'),
    'form-controls': () => import(/* webpackChunkName: 'Forms' */ '@/components/Form/FormControls'),
    'dialog-connect-wo': () => import(/* webpackChunkName: 'DialogConnectWo' */ '@/components/Shared/ActivityDialogConnectToOpenWO/Index'),
    'dialog-status-repair-order': () => import(/* webpackChunkName: 'DialogStatusRepairOrder' */ '@/components/Shared/ActivityDialogStatusEmailRepairOrder'),
    'dialog-new-instruction-repair-order': () => import(/* webpackChunkName: 'DialogNewInstructionRepairOrder' */ '@/components/Shared/ActivityDialogNewInstructionRepairOrder')
  },
  computed: {
    isAvailableToSave () {
      return this.hasCreateNew
    },
    apiAutoSave () {
      return `Stocks/Patch/${this.currentID}`
    },
    canOpenRepairStatus () {
      const { partID, partSN } = this.formData
      return !(partID && partSN)
    },
    formTitle () {
      let title = []
      this.viewData.partNumber && title.push(this.viewData.partNumber)
      this.formData.partSN && title.push(this.formData.partSN)
      return title.join(' - ') || this.checkEs6AndRun(this.title)
    },
    currentUser () {
      return this.$store.getters.get('currentUser')
    },
    isAllowToEditRFQs () {
      return this.permission(this.$store.getters.get('permissions'), 'isAllowToEditRFQs')
    }
  },
  methods: {
    filterValueTemplate (partID) {
      const { partSN } = this.formData
      if (!partID) {
        return Promise.reject(new Error(`part is expected`))
      }
      if (!partSN) {
        return Promise.reject(new Error(`partSN is expected`))
      }
      return Promise.resolve(`partID == ${partID} && partSN == "${partSN}"`)
    },
    handleOpenRepairStatus () {
      const { partSN, partID } = this.formData
      this.$refs['dialog-connect-wo'].show({ partSN, partID })
    },
    handlerQuickRFQ () {
      this.$emit('on-quick-rfq', { row: { id: this.data.id, statusID: this.data.statusID } })
    },
    formModel () {
      return new ModelStock()
    },
    handleOpenFile (formValue) {
      OpenFile.open(this.currentUser, formValue)
    },
    handleDialogClose () {
      this.setCommand('cancel')
    }
  }
}
</script>
